import { Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Fragment, useEffect, useState } from 'react';
import styled from 'styled-components';
import { useAudioInputVolumeMeter } from './useAudioInputVolumeMeter';

const ledColor = [
  '#064dac',
  '#064dac',
  '#064dac',
  '#06ac5b',
  '#15ac06',
  '#4bac06',
  '#80ac06',
  '#acaa06',
  '#ac8b06',
  '#ac5506',
];

type LedProps = {
  background: string;
};

const Led = styled('div')<LedProps>(({ background }: LedProps) => ({
  backgroundColor: background,
  width: 3,
  height: 12,
  borderRadius: 4,
}));

type Props = {
  selected: boolean;
};

export const AudioInputVolumeMeter = ({ selected }: Props) => {
  const [activeColors, setActiveColors] = useState<(string | undefined)[]>();
  const { listening, volume, listenMusic, stopListenMusic } =
    useAudioInputVolumeMeter();

  const theme = useTheme();

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    listenMusic();
    return () => stopListenMusic();
  }, []);

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (!selected || !listening || !ledColor) return;
    const range = Math.round(volume);
    const newActiveColors = [
      ...ledColor.map((color, index) => (index < range ? color : undefined)),
    ];
    setActiveColors(newActiveColors);
  }, [selected, listening, volume, ledColor]);

  return (
    <Stack direction="row" gap={0.25}>
      {ledColor.map((led, index) => (
        <Fragment key={index}>
          <Led background={activeColors?.[index] || theme.palette.divider} />
        </Fragment>
      ))}
    </Stack>
  );
};
